module.exports = __webpack_public_path__ + "fonts/7f86eee.woff2";